module.exports = __webpack_public_path__ + "media/images/logo_full-5bb5fbb8.png";